import React, { useState } from "react";
import { makeStyles, Typography, Grid, Box } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

import { header, AppName } from "../../sample";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import SettingHeader from "../../../../../components/SettingHeader";
import { Button } from "../../../../../components/base";
import { Success } from "../../../../../components/modals/Success";
import { SettingActions } from "../../../../../components/SettingHeader/settingActions";

export const useStyles = makeStyles(() => ({
  headerContent: {
    marginLeft: 50,
    paddingTop: 40,
  },
  container: {
    padding: 20,
  },
  innercontainer: {
    backgroundColor: COLORS.green,
    padding: "2px 3px",
    borderRadius: 4,
  },
  newtext: {
    color: COLORS.white,
    fontSize: 11,
  },
  IsConnected: {
    padding: "10px 20px",
  },
}));

export const PrassIntegrations = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <SettingActions />
      <ShaDowBox style={{ height: "100%" }}>
        <Grid className={classes.headerContent}>
          <SettingHeader
            title={header.prassintegrations.title}
            subtitle={header.prassintegrations.subtitle}
            img={header.prassintegrations.img}
          />
          <Grid xs={6} style={{ marginTop: 40 }}>
            <ShaDowBox
              style={{
                border: `1px solid ${COLORS.darks[0][10]}`,
                padding: 10,
              }}
            >
              <Grid
                className={classes.container}
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Box style={{ display: "flex" }}>
                  <Box className={classes.innercontainer}>
                    <Typography className={classes.newtext}>NEW</Typography>
                  </Box>
                  <Typography style={{ marginLeft: 10 }}>App name comes here </Typography>
                </Box>
                <Box>
                  <Button
                    id="CONNECT"
                    rootStyle={classes.loginBtn}
                    text="CONNECT"
                    onClick={() => setOpen(true)}
                  />
                </Box>
              </Grid>
              {AppName.map((item, i) => (
                <Grid
                  key={i}
                  className={classes.IsConnected}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography>{item} </Typography>
                  </Box>
                  <Box style={{ marginRight: "10px" }}>
                    <Typography style={{ color: "#45941E" }}>Is Connected</Typography>
                  </Box>
                </Grid>
              ))}
            </ShaDowBox>
          </Grid>
        </Grid>
        <Success
          isOpen={isOpen}
          setOpen={setOpen}
          navigate={navigate}
          subMsg="We’ll be in touch"
          successMsg="Your request to integrate with XXXXX was sent to carboobnzero"
        />
      </ShaDowBox>
    </>
  );
};
